import Carousel from '@/components/carousel/Carousel'
import CurrentEvent from '@/components/currentEvent/CurrentEvent'
import Divider from '@/components/divider/Divider'
import Image from '@/components/image/Image'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import YouTubeIcon from '@mui/icons-material/YouTube'
import Grid from '@mui/material/Grid2'
import IconButton from '@mui/material/IconButton'
import Link from '@mui/material/Link'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import React from 'react'

const footerImages = [
  '/images/statics/cleaning.jpg',
  '/images/statics/fika-3.jpg',
  '/images/statics/recording.jpg',
  '/images/history/ostersjofestivalen-4.jpg',
]

const latestNewImages = [
  '/images/history/dance-macabre-2026/dance-macabre-2026-1.jpg',
  '/images/history/dance-macabre-2026/dance-macabre-2026-2.jpg',
  '/images/history/dance-macabre-2026/dance-macabre-2026-3.jpg',
  '/images/history/dance-macabre-2026/dance-macabre-2026-4.jpg',
]

const Home: React.FC = () => {
  const theme = useTheme()
  // Returnerar true om skärmen är mindre än 'md' (standard är 900px i MUI)
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Grid size={10}>
        <Typography
          variant="h1"
          fontWeight="700"
          sx={{
            marginBottom: 0,
            marginTop: '25px',
            fontSize: { xs: '1.5em', md: '2em' },
          }}
        >
          Välkommen till Sveriges äldsta Scoutmusikkår!
        </Typography>
        <Typography
          variant="h2"
          fontWeight="700"
          sx={{
            marginTop: 0,
            fontSize: '1em',
          }}
        >
          Följ oss på Instagram{' '}
          <IconButton
            aria-label="Instagram"
            sx={{ color: '#000000' }}
            onClick={() =>
              window.open('https://www.instagram.com/scoutmusikkaren/')
            }
          >
            <InstagramIcon />
          </IconButton>
          Facebook{' '}
          <IconButton
            aria-label="Facebook"
            sx={{ color: '#000000' }}
            onClick={() =>
              window.open('https://www.facebook.com/scoutmusikkaren')
            }
          >
            <FacebookIcon />
          </IconButton>{' '}
          och Youtube{' '}
          <IconButton
            aria-label="Youtube"
            sx={{ color: '#000000' }}
            onClick={() =>
              window.open(
                'https://www.youtube.com/@KarlshamnsScoutmusikk%C3%A5r',
              )
            }
          >
            <YouTubeIcon />
          </IconButton>
        </Typography>
      </Grid>

      <Grid size={{ xs: 11, md: 10 }}>
        <Image
          src="/images/statics/groupimage-2024.jpg"
          alt="Gruppbild"
          loading="eager"
          skeletonHeight={821}
        />
      </Grid>

      <Divider size={{ xs: 11, md: 8 }} />

      <CurrentEvent />

      <Divider size={{ xs: 11, md: 8 }} />

      <Grid size={{ xs: 11, md: 6 }}>
        <h2>Senaste nytt</h2>
        <h3>Dance Macabre – vilken kväll!</h3>
        <p style={{ textAlign: 'start' }}>
          Rök, rysningar och ett rejält musikaliskt ös! Med Dance Macabre fyllde
          vi Lokstallarna med både toner och tät dimma. Ett stort tack till alla
          er som kom, lyssnade och gjorde kvällen till en riktig höjdare!
        </p>
        {isMobile ? (
          <Carousel images={latestNewImages} />
        ) : (
          <Grid
            container
            size={{ xs: 12 }}
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            {latestNewImages.map((src, index) => (
              <Grid key={index} size={{ xs: 12, md: 6 }}>
                <Image src={src} alt={`Östersjö ${index + 1}`} />
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>

      <Divider size={{ xs: 11, md: 8 }} />

      <Grid size={{ xs: 11, md: 6 }}>
        <h2>Detta är Karlshamns Scoutmusikkår</h2>
        <p style={{ textAlign: 'start' }}>
          Vi är en ideell förening där musik och gemenskap står i centrum. Vi
          spelar på konserter, parader och andra evenemang - och har roligt
          tillsammans både på och utanför scenen.
        </p>
      </Grid>
      <Grid size={{ xs: 11, md: 6 }}>
        <h2>
          <Link href="/contact">Klicka här för att kontakta oss!</Link>
        </h2>
      </Grid>
      <Grid size={{ xs: 11, md: 10 }}>
        <Image
          src="/images/history/gilla-karlshamn-2026/gilla-karlshamn-2026-1.jpg"
          alt="GillaKarlshamn"
          photographer="Cecilia Jägenmark"
          caption={
            <>
              <Link
                href="https://gillakarlshamn.se/gilla-karlshamngalan/slutsalt-till-galan-igen/"
                sx={{ ml: 1 }}
              >
                Röj på Gilla Karlshamn galan 2026
              </Link>
            </>
          }
        />
      </Grid>

      <Divider size={{ xs: 11, md: 8 }} />

      <Grid sx={{ marginBottom: '50px' }}>
        <Carousel images={footerImages} />
      </Grid>
    </Grid>
  )
}

export default Home
